/**
 * mockMessaging — MessagingPort adapter that simulates successful sends.
 *
 * Used as V0.01 default. The UI "Enviar" button becomes fully interactive
 * without any real API key. Real adapters (whatsapp.js, sms.js, email.js)
 * share the exact same surface.
 */
export function createMockMessaging() {
  const sent = [];
  return {
    async availableChannels() {
      return ["whatsapp", "sms", "email", "call_prompt"];
    },
    async channelStatus() {
      return { status: "connected" };
    },
    async send({ actor, channel, body }) {
      const providerMessageId = `mock-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
      sent.push({ actorId: actor.id, channel, body, providerMessageId, at: new Date().toISOString() });
      return { ok: true, providerMessageId };
    },
    __sent() { return sent.slice(); },
  };
}
